import { useId } from "react";
import { BOX, Gradient, U } from "../loader/UsendMarks";
import styles from "./welcome.module.css";

const STEPS = ["Account", "Workspace", "Get started"];

// "1 Account · 2 Workspace · 3 Get started" above every welcome modal.
export function WelcomeSteps({ current }) {
  return (
    <ol className={styles.steps} aria-label="Setup steps">
      {STEPS.map((label, i) => {
        const n = i + 1;
        const state = n === current ? styles.current : n < current ? styles.done : "";
        return (
          <li key={label} className={state} aria-current={n === current ? "step" : undefined}>
            <b>{n}</b>
            <span>{label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export const Svg = ({ d, ...rest }) => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
    <path d={d} />
  </svg>
);

export const CHECK = "M3.5 8.5l3 3 6-7";

const PIECES = [
  ["rect", "#8348FF", -120, -24, 160],
  ["rect", "#FFC53D", -76, -46, -120],
  ["rect", "#318BFF", -30, -56, 200],
  ["rect", "#12B76A", 18, -60, -180],
  ["rect", "#FF6B6B", 60, -50, 140],
  ["rect", "#5B6AFF", 104, -34, -220],
  ["rect", "#FFC53D", 140, -8, 260],
  ["rect", "#12B76A", -150, 0, -150],
  ["circle", "#FF6B6B", -96, -58, 90],
  ["circle", "#8348FF", 82, -62, 90],
  ["circle", "#318BFF", 160, -30, 90],
  ["circle", "#FFC53D", -44, -70, 90],
];

// The U-Send mark hops once and throws confetti. The card around it must clip (overflow hidden).
export function ConfettiLogo() {
  const id = `welcome-cf-${useId().replace(/:/g, "")}`;
  return (
    <svg className={styles.confetti} width="110" height="120" viewBox="0 0 120 130" aria-hidden="true">
      <Gradient id={id} />
      <ellipse cx="60" cy="121" rx="36" ry="4" fill="#17171A" fillOpacity="0.1" />
      <g transform="translate(60 22)">
        {PIECES.map(([shape, fill, dx, dy, r], i) => {
          const style = { "--dx": `${dx}px`, "--dy": `${dy}px`, "--r": `${r}deg` };
          return shape === "rect" ? (
            <rect key={i} className={styles.cf} x="-2" y="-4" width="4" height="8" rx="1" fill={fill} style={style} />
          ) : (
            <circle key={i} className={styles.cf} r="2.5" fill={fill} style={style} />
          );
        })}
      </g>
      <g className={styles.cfBox}>
        <path d={BOX} fill={`url(#${id})`} />
        <path d={U} fill="none" stroke="#FFFFFF" strokeWidth="4.5" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

// First letters of the store name, for a store without a logo.
export const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("") || "S";
